module.exports = __webpack_public_path__ + "img/startapplication-md.68bca55f.png";